import { isProfitPlus2k8SyncActivated } from '../api/configuration';
import type { ProfitPlus2k8OrgConfig } from '../models/configuration';
import type { Order } from '../models/order';
import { CONFIRMATION_SECONDARY_BLOCK_DELIMITER } from './confirmationDialogMessage';
import { profitPlusSyncedAtMsFromIntegration } from './profitPlusTimestamp';

/** Shown when Profit Plus sync is active and the row was exported / linked to Profit (secondary modal block). */
const PROFIT_MANUAL_DELETE_NOTICE_SINGLE_ES =
  'Importante: Este registro ya fue sincronizado con Profit Plus. Para eliminarlo también en Profit debe hacerlo manualmente allí; la integración actual no permite eliminarlo directamente desde esta aplicación.';

const PROFIT_MANUAL_DELETE_NOTICE_BULK_ES =
  'Importante: Al menos uno de los registros seleccionados ya fue sincronizado con Profit Plus. Para eliminarlos también en Profit debe hacerlo manualmente allí; la integración actual no permite eliminarlo directamente desde esta aplicación.';

/** True when `profitPlus2k8.syncedAt` is set (export / sync completed at least once). */
export function profitPlusIntegrationWasSynced(pp: unknown): boolean {
  return profitPlusSyncedAtMsFromIntegration(pp) != null;
}

/** Profit Plus dbo.pedidos.fact_num when the sale was exported. */
export function getProfitPedidoFactNum(order: Order): number | undefined {
  const n = order.profitPlus2k8?.fact_num;
  if (n == null || !Number.isFinite(Number(n))) return undefined;
  return Number(n);
}

/** True when this sale was exported or linked to Profit Plus (pedido in ERP). */
export function orderWasSyncedWithProfitPlus(order: Order): boolean {
  const pp = order.profitPlus2k8;
  if (!pp) return false;
  if (getProfitPedidoFactNum(order) !== undefined) return true;
  if (pp.syncedAt != null) return true;
  return false;
}

/**
 * Appends the manual-delete notice when Profit Plus sync is active and the entity was synced.
 * @param bulk - use plural wording when deleting multiple items and any may be synced
 */
export function appendProfitPlusManualDeleteNoticeIfNeeded(
  baseMessage: string,
  orgConfig: ProfitPlus2k8OrgConfig | null | undefined,
  entityOrAnySynced: boolean,
  options?: { bulk?: boolean }
): string {
  if (!isProfitPlus2k8SyncActivated(orgConfig) || !entityOrAnySynced) {
    return baseMessage;
  }
  const extra = options?.bulk
    ? PROFIT_MANUAL_DELETE_NOTICE_BULK_ES
    : PROFIT_MANUAL_DELETE_NOTICE_SINGLE_ES;
  return baseMessage + CONFIRMATION_SECONDARY_BLOCK_DELIMITER + extra;
}
